export default function HeroSection() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const expertStats = [
    { value: '18+', label: 'лет практики' },
    { value: '100+', label: 'корпоративных проектов' },
    { value: '450+', label: 'тренингов' },
    { value: '4500+', label: 'участников' },
  ];

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://storage.readdy-site.link/project_files/a74a1966-be20-475d-bd44-2c6a9fc46c98/e710e42b-e287-430c-bcda-0bcd98ae0d26_compressed_IMG_1156.webp"
          alt="Алексей Сивко — корпоративное обучение продажам и переговорам"
          className="absolute top-1/2 left-1/2 w-[177.77777778vh] min-w-full h-[56.25vw] min-h-full -translate-x-1/2 -translate-y-1/2 object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/70 to-black/80"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 w-full pt-32 md:pt-24 pb-12 md:pb-16">
        <div className="grid lg:grid-cols-5 gap-8 lg:gap-12 items-center">
          {/* Left content */}
          <div className="lg:col-span-3">
            <h1 className="text-2xl md:text-4xl lg:text-5xl font-extrabold text-white mb-5 leading-tight">
              Корпоративное обучение продажам и переговорам для компаний
            </h1>
            <p className="text-sm md:text-lg text-white/85 mb-8 leading-relaxed max-w-xl">
              Помогаю компаниям выстраивать сильные отделы продаж через диагностику, корпоративное обучение, практику, внедрение инструментов и сопровождение.
            </p>

            <div className="flex flex-col sm:flex-row gap-3 mb-8">
              <button
                onClick={() => scrollTo('contact')}
                className="bg-teal-600 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-sm sm:text-base font-semibold hover:bg-teal-700 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
              >
                Подобрать программу обучения
                <i className="ri-arrow-right-line"></i>
              </button>
              <button
                onClick={() => scrollTo('contact')}
                className="border border-white/30 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-sm sm:text-base font-semibold hover:bg-white/10 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
              >
                Обсудить задачи компании
                <i className="ri-chat-3-line"></i>
              </button>
            </div>
          </div>

          {/* Right - Expert Card */}
          <div className="lg:col-span-2 bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl p-5 md:p-6 text-white">
            <div className="flex items-center gap-4 mb-5">
              <div className="w-16 h-16 md:w-20 md:h-20 rounded-full overflow-hidden flex-shrink-0 border-2 border-white/30">
                <img
                  src="https://storage.readdy-site.link/project_files/a74a1966-be20-475d-bd44-2c6a9fc46c98/e710e42b-e287-430c-bcda-0bcd98ae0d26_compressed_IMG_1156.webp"
                  alt="Алексей Сивко"
                  className="w-full h-full object-cover"
                />
              </div>
              <div>
                <h3 className="text-lg md:text-xl font-bold">Алексей Сивко</h3>
                <p className="text-white/70 text-xs md:text-sm">Практикующий бизнес-тренер</p>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-3">
              {expertStats.map((stat, i) => (
                <div key={i} className="bg-white/10 rounded-xl p-3 text-center">
                  <div className="text-xl md:text-2xl font-extrabold text-teal-400">{stat.value}</div>
                  <div className="text-white/60 text-xs mt-0.5">{stat.label}</div>
                </div>
              ))}
            </div>

            <p className="text-white/60 text-xs mt-4 leading-relaxed">
              Работал с компаниями Беларуси, России, Казахстана и Израиля.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}